const minChars = charMin => string => string.trim().length >= charMin;

const noDigits = string => {
    const containsDigits = str => /\d/.test(str);
    return !containsDigits(string);
};

export const nameFieldValidation = [
    {
        isValid: minChars(1),
        errorMsg: "Please enter a billing name."
    },
    {
        isValid: noDigits,
        errorMsg: "Name cannot contain numerals"
    }
];
